import { css } from '@emotion/react';
import { FC } from 'react';

import LinkIcon from '@/assets/icons/ic-link-outer.svg';

import { BREAKPOINTS } from '@/styles/themes/default';

import { GhostButton } from '../core/Button/variants/GhostButton';
import { HollowButton } from '../core/Button/variants/HollowButton';

const linkIconCss = css`
  margin-left: 8px;
  display: none;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    display: inline-block;
  }
`;

interface ISponsorButtonProps {
  text: string;
  onClick: () => void;
  variant?: 'ghost' | 'hollow';
  isExternal?: boolean;
}

export const SponsorButton: FC<ISponsorButtonProps> = ({ text, variant = 'hollow', isExternal, ...restProps }) => {
  const Button = variant === 'ghost' ? GhostButton : HollowButton;

  return (
    <Button type="button" {...restProps}>
      {text}
      {isExternal && <LinkIcon css={linkIconCss} />}
    </Button>
  );
};
